import UploadInput from './UploadInput';

export default UploadInput;
